import React from 'react'
import { Divider } from '../base-ui'
import { WidgetList, NewsCard } from '.'
import { css } from '@emotion/react'

function LatestPosts({ widgetName, title, titleLines = 2, showUptitle = true }) {
    return (
        <WidgetList
            widget={widgetName}
            title={title}
            css={css`
                    .content {
                        background-color: #fff;
                    }
                    .card-title {
                        margin-bottom: 0 !important;
                    }
                    .link {
                        height: 7.5rem;
                    }
                `}
            divider={<Divider gap="5px" />}
            filterItem={false}
            itemRender={({ post }) => (
                <NewsCard
                    type="horizental"
                    titleLines={titleLines}
                    cardImage={false}
                    titleHtmlEl="h6"
                    uptitleLines={showUptitle}
                    titleFontSize="0.95rem"
                    horizentalImageSize="narrow"
                    contentStyle={{
                        fontSize: '0.9rem'
                    }}
                    news={post}
                />
            )}
        />
    )
}

export default LatestPosts
